// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("./next/Next.bs.js");
let React = require("react");
let JsxRuntime = require("react/jsx-runtime");

let context = React.createContext(/* [] */0);

let make = context.Provider;

let Provider = {
  make: make
};

let Context = {
  context: context,
  Provider: Provider
};

function PathHistory(props) {
  let router = Next.useRouter();
  let path = Next.Router.asPath(router);
  let match = React.useState(() => /* [] */0);
  let updateState = match[1];
  let state = match[0];
  React.useEffect(() => {
    updateState(state => ({
      hd: path,
      tl: state
    }));
  }, [path]);
  let value = state !== 0 && state.hd !== path ? ({
      hd: path,
      tl: state
    }) : state;
  return JsxRuntime.jsx(make, {
    value: value,
    children: props.children
  });
}

let make$1 = PathHistory;

exports.Context = Context;
exports.make = make$1;
/* context Not a pure module */
